import React from 'react';
import clsx from 'clsx';
import { SpinnerIcon } from '../../icons';

const Loader = ({ className }) => {
  return (
    <div
      className=""
      style={{
        position: 'fixed',
        margin: 'auto',
        zIndex: '99',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'transparent',
      }}
    >
      <SpinnerIcon className={clsx('w-10 h-10 fill-primary', className)} />
    </div>
  );
};

export default Loader;
